(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["deryan-buy-dock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('deryan-buy-dock')) {
    customElements.define('deryan-buy-dock', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-dock-button]');
        if (!this.button) return;
        this.labels = [...this.querySelectorAll('.deryan-buy-dock__label > span')];
        this.defaultLabels = this.labels.map(label => label.textContent);
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        };
        this.button.addEventListener('click', () => this.submit(), options);
        window.addEventListener('scroll', this.schedule, { ...options, passive: true });
        window.addEventListener('resize', this.schedule, options);
        window.addEventListener('pageshow', () => { this.pending = false; this.schedule(); }, options);
        window.visualViewport?.addEventListener('resize', this.schedule, options);
        document.addEventListener('variant:change', this.schedule, options);
        document.addEventListener('cart:change', () => this.finish(), options);
        document.addEventListener('cart:error', () => this.finish(), options);
        document.addEventListener('shopify:section:load', this.schedule, options);
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-busy', 'open', 'class', 'style'] });
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.pendingTimer);
      }

      findForm() {
        const root = document.querySelector('.shopify-section--main-product');
        const form = root?.querySelector('form[id^="product-form-' + this.dataset.productId + '-"]');
        const button = form?.querySelector('button[type="submit"]');
        return { root, form, button };
      }

      setValue(name, value) {
        if (this.style.getPropertyValue(name) !== value) this.style.setProperty(name, value);
      }

      isVisible(element) {
        if (!element) return false;
        const rect = element.getBoundingClientRect();
        const style = getComputedStyle(element);
        return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      }

      update() {
        const { root, form, button } = this.findForm();
        this.hidden = !form || !button;
        if (!form || !button) return;
        if (button !== this.sourceButton) {
          if (this.sourceButton) this.resizeObserver.unobserve(this.sourceButton);
          this.sourceButton = button;
          this.resizeObserver.observe(button);
        }
        const shell = document.querySelector('[id^="minimal-storefront-widget-frame-"][id$="-shell"]');
        if (shell !== this.chatShell) {
          if (this.chatShell) this.resizeObserver.unobserve(this.chatShell);
          this.chatShell = shell;
          if (shell) this.resizeObserver.observe(shell);
        }
        const chatVisible = this.isVisible(shell);
        const chatRect = chatVisible ? shell.getBoundingClientRect() : null;
        const chatOpen = chatRect && (chatRect.height > 160 || chatRect.width > 180);
        const mobile = matchMedia('(max-width: 699px)').matches;
        const gutter = mobile ? 12 : 24;
        let right = gutter;
        let left = gutter;
        let bottom = 24;
        if (chatRect && !chatOpen) {
          if (chatRect.left > innerWidth / 2) right = Math.ceil(innerWidth - chatRect.left + 8);
          else left = Math.ceil(chatRect.right + 8);
          bottom = Math.max(12, Math.round(innerHeight - chatRect.bottom + (chatRect.height - (mobile ? 60 : 72)) / 2));
        }
        this.setValue('--dock-right', right + 'px');
        this.setValue('--dock-left', left + 'px');
        this.setValue('--dock-bottom', bottom + 'px');
        const price = root.querySelector('.product-info__price sale-price .money') || root.querySelector('.product-info__price sale-price');
        if (price) {
          const clone = price.cloneNode(true);
          clone.querySelectorAll('.sr-only').forEach(node => node.remove());
          const text = clone.textContent.trim();
          this.querySelectorAll('[data-dock-price]').forEach(node => { if (node.textContent !== text) node.textContent = text; });
        }
        const busy = this.pending || button.getAttribute('aria-busy') === 'true';
        const disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
        this.button.disabled = busy || disabled;
        this.button.setAttribute('aria-busy', String(Boolean(busy)));
        this.labels.forEach((label, index) => {
          const text = disabled && !busy ? button.textContent.trim() || this.dataset.unavailable : this.defaultLabels[index];
          if (label.textContent !== text) label.textContent = text;
        });
        const rect = button.getBoundingClientRect();
        const overlays = document.querySelectorAll('#cart-drawer[open], quick-buy-drawer[open], navigation-drawer[open], search-drawer[open], .slidecarthq.open, dialog[open]');
        const blocked = [...overlays].some(element => this.isVisible(element));
        const keyboard = window.visualViewport && innerHeight - window.visualViewport.height > 160;
        const show = rect.bottom < 0 && rect.width > 0 && !chatOpen && !blocked && !keyboard;
        this.toggleAttribute('data-visible', Boolean(show));
        this.inert = !show;
      }

      submit() {
        const { form, button } = this.findForm();
        if (!form || !button || button.disabled || button.getAttribute('aria-busy') === 'true' || this.pending) return;
        if (!form.checkValidity()) {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          form.reportValidity();
          return;
        }
        this.pending = true;
        this.update();
        button.click();
        this.pendingTimer = setTimeout(() => this.finish(), 1200);
      }

      finish() {
        this.pending = false;
        clearTimeout(this.pendingTimer);
        this.schedule();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
